if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.select = this.querySelector('[data-sticky-atc-variant]');

        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.select?.addEventListener('change', this.onVariantSelect.bind(this));

        this.observeMainButton();

        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      get productInfo() {
        return document.getElementById(`MainProduct-${this.sectionId}`);
      }

      // Show the bar only once the main add-to-cart button has scrolled above the viewport.
      observeMainButton() {
        const target = this.mainButton;
        if (!target) return;
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
        });
        this.observer.observe(target);
      }

      onButtonClick() {
        const mainButton = this.mainButton;
        if (!mainButton || mainButton.disabled) return;
        mainButton.click();
      }

      // Mirror a variant chosen in the bar onto the main picker, which then drives the normal update flow.
      onVariantSelect() {
        const option = this.select.selectedOptions[0];
        const values = JSON.parse(option.dataset.options || '[]');
        const groups = this.productInfo?.querySelectorAll(
          'variant-selects fieldset, variant-selects .product-form__input--dropdown'
        );
        if (!groups) return;

        let lastChanged;
        values.forEach((value, index) => {
          const group = groups[index];
          if (!group) return;

          const select = group.querySelector('select');
          if (select) {
            const match = Array.from(select.options).find((opt) => opt.value === value);
            if (!match || match.selected) return;
            Array.from(select.options).forEach((opt) => opt.removeAttribute('selected'));
            match.setAttribute('selected', 'selected');
            select.value = value;
            lastChanged = select;
            return;
          }

          const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
          if (radio && !radio.checked) {
            radio.checked = true;
            lastChanged = radio;
          }
        });

        lastChanged?.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onVariantChange({ data }) {
        if (data.sectionId !== this.sectionId) return;
        const { variant } = data;

        const mainPrice = document.getElementById(`price-${this.sectionId}`);
        const price = this.querySelector('[data-sticky-atc-price]');
        if (mainPrice && price) price.innerHTML = mainPrice.innerHTML;

        if (this.select && variant) this.select.value = variant.id;

        const image = this.querySelector('.sticky-atc__img');
        const src = variant?.featured_media?.preview_image?.src;
        if (image && src) {
          image.removeAttribute('srcset');
          image.src = `${src}${src.includes('?') ? '&' : '?'}width=120`;
        }

        const available = Boolean(variant?.available);
        this.button.disabled = !available;
        this.button.textContent = available ? this.button.dataset.label : window.variantStrings?.soldOut || 'Sold out';
      }
    }
  );
}
